const OBSERVABLE_ANCHOR_OFFSET = '200px 0px 200px 0px';

/**
 * Observer used to track when element appears on the screen, or intersects with container
 *
 * @param anchor - watched element i.e. button at the end of infinite loading list
 * @param callback - function called when first registering listener, and later on intersection
 * @param root - scrollable container, defaults to document
 * @returns clean up function
 */
export const observeAnchor = (
  anchor: HTMLDivElement | null,
  callback: (isIntersecting: boolean) => void,
  root?: HTMLDivElement
) => {
  if (!anchor) return;

  const eventHandler = (entries: IntersectionObserverEntry[]) => {
    const lastEntry = entries[entries.length - 1];
    callback(lastEntry.isIntersecting);
  };
  const intersectionObserver = new IntersectionObserver(eventHandler, {
    root,
    rootMargin: OBSERVABLE_ANCHOR_OFFSET,
  });
  intersectionObserver.observe(anchor);

  return () => intersectionObserver.disconnect();
};
